import { apiGet } from "../../utils/axios.js";
import apiEndpoints from "../../apiEndpoints.js";

export function getDigitalAsset(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.digitalAsset()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'DIGITAL_ASSET_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'DIGITAL_ASSET_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getDigitalFootPrint(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.digitalFootPrint()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'DIGITAL_FOOT_PRINT_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'DIGITAL_FOOT_PRINT_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getFindings(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.findings()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'FINDINGS_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'FINDINGS_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getBrandInsight(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.brandInsight()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'BRAND_INSIGHT_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'BRAND_INSIGHT_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getInfraStructure(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.infraStructure()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'INFRASTRUCTURE_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'INFRASTRUCTURE_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getOrganizationHackerScore(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.organizationHackerScore()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'ORGANIZATION_HACKER_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'ORGANIZATION_HACKER_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getDomainHackerScore(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.domainHacerScore()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'DOMAIN_HACKER_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'DOMAIN_HACKER_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getbubbleChartValue(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.landscapeStats()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'LANDSCAPE_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'LANDSCAPE_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getCountryStats(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.countryStats()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'COUNTRY_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'COUNTRY_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getDarkWebStats(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.darkWebStats()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'DARK_WEB_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'DARK_WEB_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getTopVulnerableSubdomain(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.vulnerableSubdomain()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'VULNERABLE_SUBDOMAIN_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'VULNERABLE_SUBDOMAIN_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getTopVulnerableIpaddress(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.vulnerableIpAddress()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'VULNERABLE_IP_ADDRESS_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'VULNERABLE_IP_ADDRESS_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getTopVulnerableCategory(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.vulnerableCategory()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'VULNERABLE_CATEGORY_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'VULNERABLE_CATEGORY_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getTopVulnerabilityStats(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.vulnerableStats()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'VULNERABILITY_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'VULNERABILITY_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getBecData(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.becData()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'BEC_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'BEC_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getSSLExpiry(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.sslExpiry()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'SSL_EXPIRY_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SSL_EXPIRY_STATS_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function getDomainRiskScore(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.domainRiskScore()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'DOMAIN_RISK_SCORE_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'DOMAIN_RISK_SCORE_SUCCESS',
                    payload: response.detail
                })
            }        
        } catch(error) {
            console.log(error)
        }
    }
}

export function getDomainRiskScoreOverview(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.dashboard.domainRiskScoreOverview()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'DOMAIN_RISK_SCORE_OVERVIEW_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'DOMAIN_RISK_SCORE_OVERVIEW_SUCCESS',
                    payload: response.detail
                })
            }        
        } catch(error) {
            console.log(error)
        }
    }
}